import { defineMessages } from "react-intl";

export const messages = defineMessages({
  shortcutTitle: {
    id: "rovo-extension.announcements.shortcuts.title",
    defaultMessage: "Extension shortcuts: Search and Chat even faster",
    description:
      "The text is shown as the main heading of an announcement card or modal introducing keyboard shortcut features for the Rovo browser extension, specifically for Search and Chat actions.",
  },
  shortcutIntro: {
    id: "rovo-extension.announcements.shortcuts.intro",
    defaultMessage: "You can now use keyboard shortcuts to quickly access the best features in the extension.",
    description: "Introduction text for shortcuts announcement",
  },
  chatTitle: {
    id: "rovo-extension.announcements.shortcuts.chat.title",
    defaultMessage: "Chat",
    description:
      "The text is shown as a section heading within the shortcuts announcement, labelling the Chat shortcut subsection that describes how to open the Rovo chat feature.",
  },
  macChatAccess: {
    id: "rovo-extension.announcements.shortcuts.mac-chat-access",
    defaultMessage: "Access your extension-powered Chat at any time by pressing CMD + Shift + Y.",
    description: "Chat shortcut instructions for Mac OS users",
  },
  windowsChatAccess: {
    id: "rovo-extension.announcements.shortcuts.windows-chat-access",
    defaultMessage: "Access your extension-powered Chat at any time by pressing CTRL + Shift + Y.",
    description: "Chat shortcut instructions for windows users",
  },
  searchTitle: {
    id: "rovo-extension.announcements.shortcuts.search.title",
    defaultMessage: "Search",
    description:
      "The text is shown as a section heading within the shortcuts announcement, labelling the Search shortcut subsection that describes how to use Rovo-powered search.",
  },
  searchAnytimeTitle: {
    id: "rovo-extension.announcements.shortcuts.search.anytime.title",
    defaultMessage: "Anytime, anywhere",
    description:
      "The text is shown as a sub-heading within the Search shortcuts announcement section, introducing the feature that lets users search from anywhere in the browser at any time.",
  },
  searchAnytimeDesc: {
    id: "rovo-extension.announcements.shortcuts.search.anytime.description",
    defaultMessage: "From the address bar: Press r + space to perform a Rovo-powered search instantly.",
    description:
      'The text is shown as a descriptive paragraph within the shortcuts announcement, explaining to users how to trigger a Rovo-powered search from the browser address bar using the "r + space" keyboard shortcut.',
  },
  searchNewTabTitle: {
    id: "rovo-extension.announcements.shortcuts.search.newtab.title",
    defaultMessage: "In your new tab Rovo page",
    description:
      "The text is shown as a sub-heading within the Search shortcuts announcement section, introducing the search shortcut available on the Rovo new tab page.",
  },
  searchNewTabMacDesc: {
    id: "rovo-extension.announcements.shortcuts.search.newtab.mac-description",
    defaultMessage:
      "If you're not in the address bar (you can hit tab to focus out of this), press CMD + B to jump into the Search box.",
    description: "Description for new tab search feature for mac users",
  },
  searchNewTabWindowsDesc: {
    id: "rovo-extension.announcements.shortcuts.search.newtab.windows-description",
    defaultMessage:
      "If you're not in the address bar (you can hit tab to focus out of this), press CTRL + B to jump into the Search box.",
    description: "Description for new tab search feature for windows users",
  },
  shortcutGifAlt: {
    id: "rovo-extension.announcements.shortcuts.images.shortcut-gif",
    defaultMessage: "How to use search shortcut",
    description:
      "The text is used as the alt attribute for an animated GIF image shown in the shortcuts announcement, demonstrating how to use the search shortcut keyboard combination.",
  },
  chatShortcutAlt: {
    id: "rovo-extension.announcements.shortcuts.images.chat-shortcut",
    defaultMessage: "Chat shortcut",
    description:
      "The text is used as the alt attribute for an image shown in the shortcuts announcement, illustrating the keyboard shortcut keys used to open the Rovo chat feature.",
  },
  searchShortcutAlt: {
    id: "rovo-extension.announcements.shortcuts.images.search-shortcut",
    defaultMessage: "Search shortcut",
    description:
      "The text is used as the alt attribute for an image shown in the shortcuts announcement, illustrating the keyboard shortcut keys used to trigger a Rovo-powered search.",
  },
  themingTitle: {
    id: "rovo-extension.announcements.theming.title",
    defaultMessage: "Company theming for your Rovo sites",
    description:
      "The text is shown as the main heading of an announcement card or modal that introduces the company theming feature, allowing organisations to customise the appearance of their Rovo new tab page.",
  },
  themingIntro: {
    id: "rovo-extension.announcements.theming.intro",
    defaultMessage: "<bold>Company Theming for the Rovo Browser Extension is Now Live!</bold>",
    description: "Introduction text for theming announcement",
  },
  themingDescriptionFirstSection: {
    id: "rovo-extension.announcements.theming.description.1",
    defaultMessage:
      "Imagine transforming your Rovo new tab page with a touch of your company's distinctive style. Organization administrators can customize the navigation of the Rovo new tab by adding a unique company logo and background.",
    description:
      "The text is shown as the first descriptive paragraph in the company theming announcement modal, introducing the concept of customising the Rovo new tab page with company branding.",
  },
  themingDescriptionSecondSection: {
    id: "rovo-extension.announcements.theming.description.2",
    defaultMessage:
      "This enhancement goes beyond aesthetics; it highlights how your company is integrating AI into everyday workflows.",
    description:
      "The text is shown as the second descriptive paragraph in the company theming announcement modal, explaining that the theming feature also signals the company's adoption of AI in daily workflows.",
  },
  themingDescriptionThirdSection: {
    id: "rovo-extension.announcements.theming.description.3",
    defaultMessage:
      "You can find this feature in the admin console settings located on the extension options page, <bold>accessible to all organization administrators</bold>. <link>Find more directions here</link>.",
    description: "Last section of theming description with bold text and link",
  },
  themingImageBeforeAlt: {
    id: "rovo-extension.announcements.theming.images.alt",
    defaultMessage: "Preview of the Rovo Browser Extension new tab page before theming",
    description:
      "The text is used as the alt attribute for an image in the theming announcement showing the Rovo browser extension new tab page in its default appearance before any company theming has been applied.",
  },
  themingImageAfterAlt: {
    id: "rovo-extension.announcements.theming.images.alt",
    defaultMessage: "Preview of the Rovo Browser Extension after theming",
    description:
      "The text is used as the alt attribute for an image in the theming announcement showing the Rovo browser extension new tab page after company theming colours and branding have been applied.",
  },
});
